import { updateObject } from "../../shared/utility";
import { reelsConstants } from "../../constants";

// getting the default actions name from defined constants via decomposition
const {
  GET_REEL_DETAILS,
  GET_RECAP_FEEDBACK,
  GET_REEL_TYPE_BY_ID,
  GET_REELS_BY_EVENT_ID,
  GET_REEL_TYPE_DETAILS,
  GET_RECAP_TYPE_DETAILS,
  GET_ASSIGNED_REEL_EVENTS,
  GET_UNASSIGNED_REEL_EVENTS,
  GET_REELS_BY_EVENT_GROUP_ID,
  SET_REEL_DETAIL_MODAL_REEL_ID,
  SET_IS_REEL_DETAIL_MODAL_OPEN,
  SET_REEL_DETAIL_MODAL_EVENT_ID,
  SET_REEL_DETAIL_MODAL_EVENT_GROUP_ID,
} = reelsConstants;

// default state
const initialState = {
  allReels: [],
  reelTypes: [],
  recapTypes: [],
  reelTypeById: {},
  recapFeedback: {},
  setReelTypeValues: {},
  assignedReelEvents: {},
  unAssignedReelEvents: [],
  isReelDetailModalOpen: false,
  reelDetailModalEventId: null,
  reelDetailModalEventGroupId: null,
  reelDetailModalReelId: null,
  reelDetail: {
    reelDetails: [],
    reelQuestionAnswers: [],
  },
};

// manupilating the state based on actions and returning the state
export const reels = (state = initialState, action) => {
  switch (action.type) {
    case GET_ASSIGNED_REEL_EVENTS:
      return updateObject(state, { assignedReelEvents: action.data });
    case GET_UNASSIGNED_REEL_EVENTS:
      return updateObject(state, { unAssignedReelEvents: action.data.items });
    case SET_IS_REEL_DETAIL_MODAL_OPEN:
      return updateObject(state, {
        isReelDetailModalOpen: !state.isReelDetailModalOpen,
      });
    case SET_REEL_DETAIL_MODAL_EVENT_ID:
      return updateObject(state, { reelDetailModalEventId: action.data });
    case SET_REEL_DETAIL_MODAL_EVENT_GROUP_ID:      
      return updateObject(state, { reelDetailModalEventGroupId: action.data });
    case SET_REEL_DETAIL_MODAL_REEL_ID:
      return updateObject(state, { reelDetailModalReelId: action.data });
    case GET_REEL_DETAILS:
      return updateObject(state, { reelDetail: action.data });
    case GET_REEL_TYPE_DETAILS:
      return updateObject(state, { reelTypes: action.data.items });
    case GET_RECAP_TYPE_DETAILS:
      return updateObject(state, { recapTypes: action.data.items });
    case GET_REEL_TYPE_BY_ID:
      return updateObject(state, { reelType: action.data.items });
    case GET_RECAP_FEEDBACK:
      return updateObject(state, { recapFeedback: action.data?.items?.event });
    case GET_REELS_BY_EVENT_ID:
    case GET_REELS_BY_EVENT_GROUP_ID:
      return updateObject(state, { allReels: action.data.items });
    default:
      return state;
  }
};
